import React, {FC, useEffect, useRef, useState} from 'react';
import {Col, Row} from 'components/Grid';
import AuthFormsWrapper from "componentsShared/AuthFormsWrapper";
import Alert from "components/Alert";
import Form, {FormItem} from "components/Form";
import {TextField} from "components/TextField";
import useForm from "hooks/useForm";
import {Link, useHistory} from "react-router-dom";
import {useGetIsAdminQuery, useSetNewPasswordMutation} from "redux/apiSlices/auth.slice";
import get from "lodash/get";
import Button from "components/Button";
import {Paragraph, Text} from "components/Typography";
import {Colors} from "styles/CssVariables";
import {RoutesNames} from 'routes/RoutesNames';
import {TSetPasswordFormUI} from 'data/types/auth.types';
import {setPasswordFormData} from "./SetPasswordForm.data";
import {TSetPasswordFormProps} from "./SetPasswordForm.types";


const {password, passwordConfirm,passwordAdmin} = setPasswordFormData;

const SetPasswordForm: FC<TSetPasswordFormProps> = ({email, temporaryPassword}) => {
    const history = useHistory();
    const {form} = useForm<TSetPasswordFormUI>();
    const [error, setError] = useState<string>('');
    const [setNewPassword, {isLoading}] = useSetNewPasswordMutation();
    const alertRef = useRef<HTMLDivElement | null>(null);
    const {data:isAdmin}=useGetIsAdminQuery({username:email})
    const onSubmit = async (values: TSetPasswordFormUI) => {
        try {
            await setNewPassword({email, password: values.password, temporaryPassword}).unwrap();
            setError('');
            history.push('/')
        } catch (err) {
            const message = get(err, ['data', 'message']) || 'Something went wrong!';
            setError(message);
        }
    }
    useEffect(() => {
        if (error) {
            alertRef.current?.scrollIntoView({block: 'end'})
        }
    }, [error])
    return (
        <Row justify='center'>
            <AuthFormsWrapper title='Create a new password'>
                <Form form={form} onFinish={onSubmit} requiredMark={false} scrollToFirstError>
                    <Row>
                        <Col span={24} ref={alertRef}>
                            <Alert type='error' message={error}/>
                        </Col>
                        <Col span={24}>
                            <FormItem name={password.name} rules={isAdmin?passwordAdmin.rules:password.rules} label={isAdmin?passwordAdmin.label:password.label}>
                                <TextField placeholder={password.placeholder} type='password'/>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem name={passwordConfirm.name} rules={passwordConfirm.rules}
                                      label={passwordConfirm.label}>
                                <TextField placeholder={passwordConfirm.placeholder} type='password'/>
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <Button htmlType='submit' loading={isLoading}>Save</Button>
                            <Paragraph className='mt-2' fontLevel={5}>
                                Or go back to{' '}
                                <Text fontLevel={5} color={Colors.DarkBlue} underline>
                                    <Link to={RoutesNames.SignIn}> Login page</Link>
                                </Text>
                            </Paragraph>
                        </Col>
                    </Row>
                </Form>
            </AuthFormsWrapper>
        </Row>
    );
};

export default SetPasswordForm;
